import { ApprovalFlowStep } from '../../entities/applicant_tracking/ApprovalFlow';
import { User } from '../../entities/User';
import {
  Requisition,
  RequisitionApprover,
} from '../../entities/v1/applicant_tracking/Requisition';

export function buildSteps(
  approvers: RequisitionApprover[],
): ApprovalFlowStep[] {
  const stepOrders: Set<number> = new Set(approvers.map((a) => a.order).sort());

  const steps: ApprovalFlowStep[] = [];

  stepOrders.forEach((order) => {
    steps.push({
      order: order,
      approvers: approvers
        .filter((approver) => approver.order === order)
        .map((approver) => {
          return {
            user: approver.user,
            answer: approver.answer,
          };
        }),
    });
  });

  return steps;
}

export function getCurrentStepOrder(steps: ApprovalFlowStep[]): number {
  return steps.find((step) =>
    step.approvers.every((approver) => !approver.answer),
  )?.order;
}

export function getApprovableStepOrders(
  requisition: Requisition,
  user: User,
): number[] {
  return requisition.approvers
    .filter((approver) => approver.user.id === user.id)
    .map((approver) => approver.order);
}
